import { useEffect, useState, useContext } from 'react'
import { useNavigate } from "react-router-dom"
import _ from "lodash"
import { enqueueSnackbar } from 'notistack'

import { Typography,Button,CircularProgress}  from '@mui/material'

import { AppContext } from '/providers/app-context'
import {saveAppleModel,saveAppleTemplate,saveGoogleData, setWizardDone, saveInstanceData} from "/providers/templates-api"

const Complete = ({setPrevButtonState,setNextButtonState, templateId,model,template,objectData,classData,instanceData}) => {

  const { apiSource, apiKey, refreshTemplates } = useContext(AppContext)
  
  const [saved,setSaved] = useState(false)

  useEffect(() => {
    setPrevButtonState("hidden")
    setNextButtonState("hidden")

    savePassTemplate()
  }, [])

  const navigate = useNavigate()

  const savePassTemplate = async () => {

    // We can remove the wizard fields now...
    let appleTemplate = _.cloneDeep(template)
    template.backFields.map(f => delete f.wizard)

    let googleClass = _.cloneDeep(classData)
    googleClass.textModulesData.map(f => delete f.wizard) 
    googleClass.linksModuleData.uris.map(f => delete f.wizard) 

    let googleObject = _.cloneDeep(objectData)
    googleObject.textModulesData.map(f => delete f.wizard) 
    googleObject.linksModuleData.uris.map(f => delete f.wizard) 

    enqueueSnackbar({ message: 'Fianlising wizard', variant: 'light' })

    await Promise.all([
      saveAppleModel({ apiSource, apiKey, templateId, appleModel: model }),
      saveAppleTemplate({ apiSource, apiKey, templateId, appleTemplate }),
      saveGoogleData({ apiSource, apiKey, templateId, googleClass,googleObject }),
      saveInstanceData({apiSource, apiKey, templateId, instanceData }),
      setWizardDone({apiSource, apiKey,templateId})
      // TODO handle error
    ])

    enqueueSnackbar({ message: 'All done', variant: 'success' })

    setSaved(true)

    refreshTemplates()
  }

  return saved ? <Saved navigate={navigate} templateId={templateId}/> : <Saving/>
}

export default Complete

const Saving = () => {
  return (
    <>
      <Typography variant="h3" sx={{ p: 2 }}>Saving your pass template</Typography>
      <Typography sx={{ p: 2 }}>This will just take a moment</Typography>
      <CircularProgress />
    </>
  )  
}

const Saved = ({navigate,templateId}) => {

  return (
    <>
    <Typography variant="h3" sx={{ p: 2 }}>Wizard complete</Typography>
    <Typography sx={{ p: 2 }}>Your pass template has been saved</Typography>

    <div className="flex flex-row justify-between mb-10">
      <Button variant="outlined" onClick={() => navigate("/templates",{replace:true})}>Go to template list</Button>
      <Button variant="contained" onClick={() => navigate(`/templates/${templateId}/edit`,{replace:true})}>Go to editor</Button>
    </div>
  </>
  )
}  